interface ITextFieldValue {
  textValue?: string | null;
  field: { key: string };
}

interface IAssetFieldValue {
  assetImageUrl?: string | null;
  assetImageUrl2x?: string | null;
  assetVideoUrl?: string | null;
  field: { key: string; fieldType: string };
}

interface IImageAssetUrls {
  x1: string;
  x2: string;
}

export const getFieldTextValue = (
  fieldValues: ITextFieldValue[],
  fieldKey: string
) => {
  const fieldValue = fieldValues.find(({ field }) => field.key === fieldKey);

  return fieldValue?.textValue;
};

export const getFieldImageAssetUrls = (
  fieldValues: IAssetFieldValue[],
  fieldKey: string
): IImageAssetUrls | null => {
  const fieldValue = fieldValues.find(({ field }) => field.key === fieldKey);

  const x1 = fieldValue?.assetImageUrl;
  const x2 = fieldValue?.assetImageUrl2x;

  if (x1 == null || x2 == null) {
    return null;
  }

  return {
    x1,
    x2,
  };
};

export const getFieldVideoAssetUrl = (
  fieldValues: IAssetFieldValue[],
  fieldKey: string
) => {
  const fieldValue = fieldValues.find(
    ({ field, assetVideoUrl }) => field.key === fieldKey && assetVideoUrl
  );

  return fieldValue?.assetVideoUrl ?? null;
};
